/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import type { PostLoginResponseBase } from 'shared-ui/api/account';

import type { AuthScreen } from '../redux/authModal.slice';

export interface AuthModalScreenContextValue {
    screen: AuthScreen;
    setScreen: (screen: AuthScreen) => void;
    closeModal: (options?: { preventRedirect?: boolean }) => void;
    cleanUpParamsAndStorage: () => void;
    storeUserData: (userData: PostLoginResponseBase) => void;
    isCloseConfirmationOpen: boolean;
    setIsCloseConfirmationOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AuthModalScreenContext = React.createContext<
    AuthModalScreenContextValue | undefined
>(undefined);

export function useAuthModalScreen(): AuthModalScreenContextValue {
    const ctx = React.useContext(AuthModalScreenContext);
    if (!ctx) {
        throw new Error(
            'useAuthModalScreen must be used within an AuthModalScreenContext.Provider'
        );
    }
    return ctx;
}
